import { render, staticRenderFns } from "./CadastroServicosPagamentos.vue?vue&type=template&id=6f0646ca&"
import script from "./CadastroServicosPagamentos.vue?vue&type=script&lang=js&"
export * from "./CadastroServicosPagamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports